import { useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { gmailLoginRequest } from 'pages/login/gmail-slice';


const AuthHandler = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    
    const exchangeToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      
      const accessTokenFromUrl = urlParams.get("access_token")
      
      if (accessTokenFromUrl) {
        
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_OAUTH_SERVER_API}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${accessTokenFromUrl}`,
                "Content-Type": "application/json",
              },
            }
          );

          if (response.status === 200) {

            interface ExchangeTokenResponse {
              message: string;
              data: {
                jwtToken: string;
                refreshToken: string;
                userName: string;
                displayName: string;
              }
            }
            const res = response.data as ExchangeTokenResponse;
            const data = res.data;
           

            if (data.jwtToken) {
              dispatch(gmailLoginRequest(data));
              window.history.replaceState({}, document.title, window.location.pathname);
            }
          }
        } catch (error) {
          console.error("AuthHandler Error:", error);
        }
      }
    };
    
    exchangeToken();
  }, []);

  return null; // This component doesn't render anything UI-wise
};

export default AuthHandler;
